<template>
	<div style="width: 100%;font-size: 12px;">
		<div style="position: relative;z-index: 10000;">
			<van-overlay :show="loading" style="background-color:#fff;z-index: 10000;">
				<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
					<van-loading color="#7d7d7d" type="spinner" />
				</div>
			</van-overlay>
		</div>
		<div style="width: 100%;" v-if="isJump">
			<iframe allow="payment" id="iframe" style="width: 100%;height: 1000px;" ref="iframe" :src="jumpUrl"
				frameborder="0" scrolling="no" @load="loading = false"></iframe>
		</div>
		<div v-show="data && data.mode != 1">
			<div v-if="!isJump && data">
				<div v-if="data && equipment == 'pc'"
					style="display: flex;align-items: center;margin: auto;;width: fit-content;padding-top: 20px;">
					<div style="width: 140px;height: 2px;background-color: #3c3d41 ;"></div>
					<div
						style="position: relative;display: flex;flex-direction: column;justify-content: center;align-items: center;">
						<div
							style="width: 30px;height: 30px;border-radius: 100%;display: flex;align-items: center;justify-content: center;color: #fff;background-color: #3c3d41;background-color: #3c3d41;">
							1</div>
						<div style="position: absolute;width: 100px;margin-top: 60px;text-align: center;">
							{{$t('h.goodCart')}}
						</div>
					</div>
					<div style="width: 260px;height: 2px;background-color: #3c3d41;"></div>
					<div
						style="position: relative;display: flex;flex-direction: column;justify-content: center;align-items: center;">
						<div
							style="width: 28px;height: 28px;border-radius: 100%;display: flex;align-items: center;justify-content: center;color: #ffffff;border: solid 2px #3c3d41;background-color: #3c3d41;">
							2</div>
						<div style="position: absolute;width: 100px;margin-top: 60px;text-align: center;">
							{{$t('h.checkout')}}
						</div>
					</div>
					<div style="width: 260px;height: 2px;background-color: #3c3d41;"></div>
					<div
						style="position: relative;display: flex;flex-direction: column;justify-content: center;align-items: center;">
						<div
							style="width: 28px;height: 28px;border-radius: 100%;display: flex;align-items: center;justify-content: center;color: #ffffff;border: solid 2px #3c3d41;background-color: #3c3d41;">
							3</div>
						<div style="position: absolute;width: 100px;margin-top: 60px;text-align: center;">
							{{$t('h.pay')}}
						</div>
					</div>
					<div style="width: 140px;height: 2px;background-color: #3c3d41;"></div>
				</div>
				<div style="width: 100%;height: 100px;"></div>
				<div :style="{
						width:equipment == 'pc'?'60%':'90%',
						paddingLeft:equipment == 'pc'?'100px':'10px'
					}" style="border: solid 1px #c3c5d1;margin: auto;padding-top: 60px;display: flex;padding-bottom: 160px;">
					<i class="el-icon-bank-card" style="color: #4caf50;font-size: 100px;" v-if="equipment == 'pc'"></i>
					<div style="margin-left: 30px;font-size: 24px;width: 100%;">
						<div style="color: #3c3d41;" v-if="data.mode != 1">
							Order placed successfully, please pay
						</div>
						<div v-if="data.mode != 1"
							style="width: calc(100% - 70px);border: solid 1px #ffaa00;background-color: #fffaf0;margin-top: 40px;padding: 26px 20px;font-size: 16px;">
							<div :style="{
								 flexDirection:equipment == 'pc'?'row':'column',
								 width:equipment == 'pc'?'70%':'90%'
							 }" style="display: flex;justify-content: space-between;: ;">
								<div v-if="data">
									Order Number: <span style="font-weight: bold;">{{data.order.number}}</span>
								</div>
								<div :style="{
									 marginTop:equipment == 'pc'?'0px':'20px'
								 }" v-if="data">
									Amount: <span style="font-weight: bold;">{{data.order.total_format}}</span>
								</div>
							</div>
							<div style="margin-top: 20px;" v-if="data">
								Payment Method：<span
									style="font-weight: bold;">{{data.order.payment_method_name}}</span>
							</div>
						</div>

						<form style="overflow: hidden;" :action="data.paypal.action" method="post"
							v-if="data.mode == 1">
							  <input type="hidden" name="cmd" value="_xclick">
							  <input type="hidden" name="custom" :value="data.paypal.custom">
							  <input type="hidden" name="item_number" :value="data.paypal.item_number">
							  <input type="hidden" name="item_name" :value="data.paypal.item_name">
							  <input type="hidden" name="business" :value="data.paypal.business">
							  <input type="hidden" name="amount" :value="data.paypal.amount">
							  <input type="hidden" name="currency_code" :value="data.paypal.currency_code">
							  <input type="hidden" name="return" :value="data.paypal.return">
							  <input type="hidden" name="notify_url" :value="data.paypal.notify_url">
							  <input type="hidden" name="cancel_return" :value="data.paypal.cancel_return">

							<input ref="orderSub"
								style="width: 70%;height: 56px;background-color: #ffaa00 ;border: solid 0px #ffffff;margin-top: 20px;border-radius: 6px;cursor: pointer;"
								type="submit" name="submit" :value="$t('h.subPay')">
							<!-- <input style="width: 70%;height: 56px;" type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_buynow_LG.gif" name="submit" alt="PayPal"> -->
							<!-- <input type="submit" value="提交">
							<div v-if="data.mode == 1" style="width: 70%;height: 56px;background-color: #ffaa00 ;display: flex;align-items: center;justify-content: center;border-radius: 6px;margin-top: 20px;cursor: pointer;">
								{{$t('h.subPay')}}
							</div> -->
						</form>

						<div id="paypal-button-container" v-if="data && data.paytype == 'Paypal' && data.mode != 1"
							style="margin-top: 20px;" class="mt-4"></div>
						<div v-if="data && data.paytype == 'Stripe' && data.mode != 1"
							style="margin-top: 20px;font-size: 16px;">
							<div>
								<img :style="{
									 width:equipment == 'pc'?'300px':'90%'
								 }" style="margin-top: 20px;" src="../img/pay-image.png" />
							</div>

							<div style="margin-top: 20px;">
								<el-form :label-position="equipment == 'pc'?'right':'top'" :model="ruleForm"
									:rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm">
									<el-form-item label="cardholder Name" prop="cardholder_Name">
										<el-input :style="{
											width:equipment == 'pc'?'260px':'90%'
										}" placeholder="cardholder Name" v-model="ruleForm.cardholder_Name"></el-input>
									</el-form-item>

									<el-form-item label="Credit Card Number">
										<div :style="{
										 	width:equipment == 'pc'?'250px':'90%'
										 }" style="border: solid 1px #e7e7e7 ;padding-left: 10px;border-radius: 6px;" id="card-number-element">
										</div>
									</el-form-item>
									<el-form-item label="Expiration Date">
										<div :style="{
										 	width:equipment == 'pc'?'250px':'90%'
										 }" style="border: solid 1px #e7e7e7 ;padding-left: 10px;border-radius: 6px;" id="card-expiry-element">
										</div>
									</el-form-item>
									<el-form-item label="cvv">
										<div :style="{
										 	width:equipment == 'pc'?'250px':'90%'
										 }" style="border: solid 1px #e7e7e7 ;padding-left: 10px;border-radius: 6px;" id="card-cvc-element">
										</div>
									</el-form-item>


									<!-- <el-form-item label="cardnum" prop="date">
										<el-date-picker style="width: 260px;" v-model="ruleForm.date" placeholder="cardnum"
											clearable type="date" format="MM / dd" />
									</el-form-item>
									<el-form-item label="cvv" prop="cvv">
										<el-input style="width: 260px;" placeholder="cvv" v-model="ruleForm.cvv"></el-input>
									</el-form-item> -->
									<el-form-item label=" ">
										<el-button class="btn-ok"
											style="background-color: #000;border: solid 1px #000;margin-top: 20px;width: 260px;"
											type="primary" @click="submit">{{$t('h.subPay')}}</el-button>
									</el-form-item>
								</el-form>
							</div>

						</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 40px;"></div>
		</div>
	</div>
</template>

<script>
	let cardNumberElement = null,
		cardExpiryElement = null,
		cardCvcElement = null,
		stripe = null,
		elements = null;
	import $ from 'jquery'
	import {
		getOrdersPayData,
		getStripeCapture
	} from '../../../api/all.js'
	export default {
		props: {
			placeNavHeight: {
				type: Number,
				default: 0
			},
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				jumpUrl: "",
				isJump: false,
				ruleForm: {
					order_number: '',
					cardnum: '',
					date: '',
					cvv: '',
					remenber: false,

					// 以上为以前自定义表单的字段
					cardholder_Name: '',
				},
				rules: {
					cardholder_Name: [{
						required: true,
						message: this.$t('h.iptCardholder_Name'),
						trigger: 'blur'
					}, ],
				},
				loading: false,
				data: null
			}
		},
		async mounted() {
			await this.getData()
		},
		methods: {
			checkedBtnCheckoutConfirm(orderId) {
				let that = this
				// 判断 stripeForm.errors 里面的值是否都为空
				// if (stripeForm.form.cardholder_Name == '') {
				// 	stripeForm.errors.cardholderName = 'Please fill out a cardholder name.'
				// }
				// // if (Object.values(stripeForm.errors).every(e => e == '')) {
				const options = {
					name: this.ruleForm.cardholder_Name,
				};
				that.loading = true

				stripe.createToken(cardNumberElement, options).then(async function(stripeResult) {
					if (stripeResult.error) {
						that.$message({
							message: stripeResult.error.message,
							type: 'error',
							offset: 200
						});
					} else {
						const data = await getStripeCapture({
							token: stripeResult.token.id,
							order_number: orderId
						})
						if (data.data.status == 'success') {
							that.loading = false
							if (that.getCookie('login')) {
								that.$router.replace({
									path: '/account/orders/' + orderId
								})
							} else {
								that.$router.replace({
									path: '/success_order_checkout/' + orderId
								})
							}

						} else {

							that.$message({
								message: data.data.message,
								type: 'info',
								offset: 200
							});
						}
						console.log('data', data)
					}
				})
			},
			getCookie(cname) {
				var name = cname + "=";
				var ca = document.cookie.split(';');
				for (var i = 0; i < ca.length; i++) {
					var c = ca[i].trim();
					if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
				}
				return "";
			},
			submit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.checkedBtnCheckoutConfirm(this.data.order.number)
					} else {
						console.log('error submit!!');


						return false;
					}
				});
			},
			loadScript(src, name) {
				return new Promise((resolve, reject) => {
					// 先检查是否已存在同名script标签
					const existingScript = document.querySelector(`script[name="${name}"]`);

					if (existingScript) {
						// 如果已存在，先移除
						existingScript.parentNode.removeChild(existingScript);
					}

					// 创建新的script标签
					const script = document.createElement('script');
					script.src = src;
					script.name = name; // 设置name属性以便后续识别
					script.async = true;

					// 加载成功回调
					script.onload = () => {
						resolve();
					};

					// 加载失败回调
					script.onerror = () => {
						reject(new Error(`Failed to load script: ${src}`));
					};

					// 添加到文档中
					document.head.appendChild(script);
				});
			},
			async getData() {
				try {
					let that = this
					this.loading = true
					const data = await getOrdersPayData({
						id: this.$route.params.id
					})
					console.log('getOrdersPayData', data)
					this.data = data.data.data
					if (this.data.bjump) {
						this.isJump = true
						this.jumpUrl = this.data.bjump


						if (this.data.redirect == 1) {
							window.location.href = this.data.bjump
							return
						}


						window.addEventListener('message', function(event) {
							console.log('eventeventevent', event)
							if (event && event.data.type == 'jump' && event.data.status == 'success') {
								if (that.getCookie('login')) {
									that.$router.replace({
										path: '/account/orders/' + that.data.order.number
									})
								} else {
									that.$router.replace({
										path: '/success_order_checkout/' + that.data.order.number
									})
								}
								// that.dialogVisible = false
								// localStorage.setItem('address', JSON.stringify(event.data.data.data))
								// that.$router.replace({
								// 	path: '/account',
								// })
								// that.$message.success(event.data.data.message)
							}
						});
					} else {
						if (this.data.mode == 1) {


							// this.$refs.orderSub.click()

							this.$nextTick(() => {
								// this.loading = true

								this.$refs.orderSub.click()

								// this.router.go(-1)
								// that.loading = false
							})



							return
						}


					}

					if (this.data.paytype == 'Paypal') {
						await this.createPaypay(this.data.order.number)
					}
					if (this.data.paytype == 'Stripe') {
						await this.createStripe(this.data.key)
					}
					//await this.createPaypay(this.data.order.number)
					this.loading = false
				} catch (e) {
					this.loading = false
				}
			},
			async createStripe(key) {
				await this.loadScript('https://js.stripe.com/v3/');
				stripe = Stripe(key);
				this.createAndMountFormElements()
			},

			// stripe生成卡号校验部分
			createAndMountFormElements() {
				// stripe 样式，带边框
				const style = {
					base: {
						color: "#32325d",
						fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
						fontSmoothing: "antialiased",
						lineHeight: "40px",
						fontSize: "16px",
						"::placeholder": {
							color: "#aab7c4"
						}
					},
					invalid: {
						color: "#fa755a",
						iconColor: "#fa755a"
					}
				}

				elements = stripe.elements({
					locale: "en" // 设置默认显示语种   en 英文 cn 中文 auto 自动获取语种
				})

				// 创建cardNumber并实例化
				cardNumberElement = elements.create("cardNumber", {
					style: style,
					showIcon: true, // 设置卡片icon，默认值为false
					placeholder: this.cardNumberplaceholder
				})

				cardNumberElement.mount("#card-number-element")

				// 创建cardExpiry并实例化
				cardExpiryElement = elements.create("cardExpiry", {
					style: style
				})
				cardExpiryElement.mount("#card-expiry-element")

				// 创建cardCvc并实例化
				cardCvcElement = elements.create("cardCvc", {
					style: style,
					placeholder: 'CVV'
				})
				cardCvcElement.mount("#card-cvc-element")
			},



			async createPaypay(orderId) {
				await this.loadScript(
					`https://www.paypal.com/sdk/js?client-id=${this.data.key}&currency=${this.data.order.currency_code}`,
					'paypay');
				let that = this
				paypal.Buttons({
					createOrder: function(data, actions) {
						const token = $('meta[name="csrf-token"]').attr('content')
						return fetch('/paypal/create', {
							method: 'POST',
							headers: {
								'X-CSRF-Token': token
							},
							body: JSON.stringify({
								orderNumber: orderId,
							})
						}).then(function(res) {
							return res.json();
						}).then(function(orderData) {
							if (orderData.error) {
								that.$message.error(common.text_hint)
								window.location.reload();
							}
							return orderData.id;
						});
					},
					onApprove: function(data, actions) {
						const token = $('meta[name="csrf-token"]').attr('content')
						return fetch('/paypal/capture', {
							method: 'POST',
							headers: {
								'X-CSRF-Token': token
							},
							body: JSON.stringify({
								orderNumber: orderId,
								paypalOrderId: data.orderID,
								payment_gateway_id: $("#payapalId").val(),
							})
						}).then(function(res) {
							// console.log(res.json());
							return res.json();
						}).then(function(orderData) {
							// Successful capture! For demo purposes:
							// console.log('Capture result', orderData, JSON.stringify(orderData, null,
							// 	2));
							let captureStatus = orderData.status
							if (captureStatus === 'COMPLETED') {
								if (that.getCookie('login')) {
									that.$router.replace({
										path: '/account/orders/' + orderId
									})
								} else {
									that.$router.replace({
										path: '/success_order_checkout/' + orderId
									})
								}
								// @if(current_customer())
								// window.location.href =
								// 	"{{ shop_route('account.order.show', $order->number) }}"
								// @else
								// location =
								// 	"{{ shop_route('checkout.success', ['order_number' => $order->number]) }}"
								// @endif
							}
						});
					}
				}).render('#paypal-button-container');
			},
			payOrder() {

			}
		}
	}
</script>

<style>
</style>